import { returnClaim } from 'feature/claims/claimSlice';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from 'store/store';
import { PopoverButton } from 'styles';
import { CLAIM_RETURN_ACTIONS } from 'types/Claim';
import { IReturnStatus } from 'types/Claims';
import { TRANSLATION_KEYS } from 'utils/constants';
import { useTranslation } from 'utils/translations';

const ClaimReturnActionButtons = () => {
	const { t: tClientLabels } = useTranslation('', {
		keyPrefix: TRANSLATION_KEYS.CLIENT_LABELS,
	});
	const dispatch = useDispatch<AppDispatch>();
	const { claimReturnStatuses } = useSelector((store: RootState) => store.form);

	const handleClickReturnAction = (action: IReturnStatus['code']) => {
		const status = claimReturnStatuses.find(s => s.code === action);
		if (!status) return;

		dispatch(returnClaim(action));
	};

	return (
		<>
			<PopoverButton
				type="button"
				variant="popoverButton"
				onClick={() =>
					handleClickReturnAction(CLAIM_RETURN_ACTIONS.RETURN_APPROVED)
				}
			>
				{tClientLabels('claim.button.approveReturn')}
			</PopoverButton>
			<PopoverButton
				type="button"
				variant="popoverButton"
				onClick={() =>
					handleClickReturnAction(CLAIM_RETURN_ACTIONS.RETURN_REJECTED)
				}
			>
				{tClientLabels('claim.button.rejectReturn')}
			</PopoverButton>
		</>
	);
};

export default ClaimReturnActionButtons;
